import React from 'react';
export var renderErrors = function renderErrors() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var errors = args.reduce(function (accumulator, arg) {
    return accumulator || arg;
  }, undefined);
  return Array.isArray(errors) ? errors.map(function (error, index) {
    return React.createElement("div", {
      key: index
    }, error);
  }) : errors;
};